import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { RegistreService } from './shared/services/registre.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private regServ = inject(RegistreService);

  ngOnInit() {
    this.regServ.getJudet();
  }
}
